export class StringUtils{
    static stripExt(input: string){
        return input.replace(".webp", "");
    }
}